import * as Types from 'constants/ActionTypes'
import { actionRequest } from './index'

export const fetchBodyHeightUnits = () => (...args) => {
    return actionRequest(...args)({
        type: Types.FETCH_BODY_HEIGHT_UNITS,
        url: `/body-height-unit-measures`,
        method: 'get'   
    })
}